import ItemView from "./ItemView";

const Placeholder = ItemView.extend(
  /** @lends Placeholder.prototype */
  {
    /**
     * View for image placeholder for drag'n'drop sorting
     * @param {ImageModel} model
     * @param opts
     * @constructs
     * @extends ItemView
     */
    constructor(model, opts) {
      ItemView.call(this, model, opts);

      this.setHTML(this.opts.template.parse("placeholder", { id: this.id }));
    },

    /**
     * Set preview src to image url
     * @param {string} url
     * @private
     */
    setPreviewUrl(url) {
      if(!url) return;

      const img = new Image();
      let didOnloadFire = false;

      const onload = () => {
        didOnloadFire = true;
        const img = this.getElement("image");
        if(!img) return; // the view is already destroyed
        img.style.backgroundImage = `url(${url})`;
      };

      img.onload = onload;
      img.src = url;

      // maybe there are some browsers, which don't fire onload for cached images, so just make sure
      if(img.complete && !didOnloadFire) { onload(); delete img.onload; }
    },

    onMount() {
      this.setPreviewUrl(this.model.url);
      this.listenTo(this.model, "url", ({ url }) => { this.setPreviewUrl(url) });
    }
  });

export default Placeholder;
